var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var Heading2Icon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M4.268 9.736L2.056 9.4V8H9.672V9.4L7.264 9.736V17.268H17.12V9.736L14.852 9.4V8H22.356V9.4L20.144 9.736V27.152L22.356 27.432V28.804H14.824V27.432L17.12 27.152V19.004H7.264V27.152L9.7 27.432V28.804H2V27.432L4.268 27.152V9.736Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M24.0968 27.7238C25.9501 26.6305 27.4701 25.4238 28.6568 24.1038C29.8435 22.7838 30.4368 21.5105 30.4368 20.2838C30.4368 19.6305 30.2301 19.1105 29.8168 18.7238C29.4168 18.3238 28.8501 18.1238 28.1168 18.1238C27.4235 18.1238 26.8368 18.2572 26.3568 18.5238C25.8901 18.7772 25.4301 19.1105 24.9768 19.5238L24.2168 18.4238C24.4835 18.0905 24.8635 17.7505 25.3568 17.4038C25.8635 17.0572 26.4501 16.7705 27.1168 16.5438C27.7835 16.3038 28.4568 16.1838 29.1368 16.1838C30.1101 16.1838 30.9235 16.3505 31.5768 16.6838C32.2435 17.0172 32.7368 17.4572 33.0568 18.0038C33.3768 18.5505 33.5368 19.1572 33.5368 19.8238C33.5368 21.1038 32.9235 22.3905 31.6968 23.6838C30.4701 24.9772 28.9101 26.1638 27.0168 27.2438L32.8168 26.7038L33.5768 25.0238L34.8368 25.2838L34.2568 28.8038H24.5168L24.0968 27.7238Z",
    fill: "black"
  }));
};
export var Heading2IconGlyph = function (props) {
  return React.createElement(Heading2Icon, __assign({}, props, {
    variant: 'glyph'
  }));
};